export const CLIENT_ID = '16107e7f89be4f32bccc58f846f77759';
export const CLIENT_PUBLIC = 'f8595197a21244059b4b3afaaab377d7';
